export default __webpack_public_path__ + "static/media/crotalaria.f963eb27.png";